module.exports = __webpack_public_path__ + "static/media/navidad_belen.07b5ba70.svg";